import { clsx } from "clsx";
import type { IconProps } from "./types";

export const CheckCircleIcon = ({ className }: IconProps) => (
  <span
    className={clsx(
      "flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-line text-white text-xl",
      className,
    )}
  >
    ✓
  </span>
);
